import loadApstagExtensions from './amazon-apstag-extensions';

/**
 * Amazon bidding library.
 */
function ANBiddingLibraryAmazon(logger){

    ANBiddingLibrary.call(this, logger);
}

ANBiddingLibraryAmazon.prototype             = Object.create(ANBiddingLibrary.prototype);
ANBiddingLibraryAmazon.prototype.constructor = ANBiddingLibrary;

/**
 * @inheritdoc
 */
ANBiddingLibraryAmazon.prototype.setupAuction = function(auction, overrideDimensions){

    auction = ANBiddingLibrary.prototype.setupAuction.call(this, auction, overrideDimensions);
    var ads = auction.getGamAdSlots();

    if(!ads || ads.length === 0){

        this.__logger.debug('Unable to setup Amazon: no ads found!', auction);
        return auction;
    }

    for(var x in ads){

        var ad                   = ads[x];
        var amazonAdUnitTemplate = ad.getAmazonAdUnitTemplate();

        if(!amazonAdUnitTemplate || typeof amazonAdUnitTemplate !== 'string'){

            this.__logger.debug('Unable to setup Amazon: no amazonAdUnitTemplate found!', ad);
            continue;
        }

        // Replace macros in template to construct a concrete Amazon ad unit.
        amazonAdUnitTemplate = amazonAdUnitTemplate.replaceAll('DIR_AD_ELEMENT_ID', ad.adElementId);
        var amazonAdUnit     = JSON.parse(amazonAdUnitTemplate);

        if('videoPlayer' === ad.renderer 
            && 'video' === amazonAdUnit.mediaType
            && window.adsNinja 
            && window.adsNinja.floorHelper 
            && typeof window.adsNinja.floorHelper.addAmazonAdElementIdOverride === 'function'
        ){

            window.adsNinja.floorHelper.addAmazonAdElementIdOverride(ad.adElementId, amazonAdUnit.slotID); // TODO: Look to remove.
        }

        auction.addAmazonAdSlot(amazonAdUnit);
        // window.adsNinjaHeaderBiddingManager.amazonAdSlots.push(amazonAdUnit);

        // Create mapping.
        window.adsNinjaHeaderBiddingManager.__adUnitSlotDetails.amazon[ad['adUnitPath']] = {
            'adElementId': ad.adElementId,
            'adUnitPath': ad.adUnitPath,
            'amazonAdSlot': amazonAdUnit,
        };
    }

    return auction;
};

/**
 * Initialize the library.
 */
ANBiddingLibraryAmazon.prototype.__init = function(){

    // Testing new APS library
    if(["SimpleFlying"].includes(window.adsNinjaHeaderBiddingManager.getBrandName())){

        loadApstagExtensions();
    }

    if(!window.adsNinjaAmazonInitData){

        this.__logger.error('Unable to initialize Amazon: window.adsNinjaAmazonInitData not found!');
        return;
    }

    // Add more data.
    var signals = {
        ortb2: {
            site: {
                cattax: 7,
                cat: [window.adsNinjaHeaderBiddingManager.getCat()],
                name: window.adsNinjaHeaderBiddingManager.getBrandName(),
                ext: {
                    template: window.adsNinjaHeaderBiddingManager.getTemplate(),
                    cat: window.adsNinjaHeaderBiddingManager.getSiteCategory(),
                    postID: window.adsNinjaHeaderBiddingManager.getPostId(),
                },
            },
        },
    };

    window.adsNinjaAmazonInitData['signals'] = signals;

    if(!window.apstag || typeof window.apstag.init !== 'function'){

        this.__logger.error('Cannot initialize Amazon. File apstag.js is not available.');

        return;
    }

    window.apstag.init(window.adsNinjaAmazonInitData);

    // Must enable Amazon Shopping Recommendations right after init.
    if(window.apstag && typeof window.apstag.customPlacements == 'function' && typeof window.adsNinjaAmazonResolve == 'function'){

        try {
            
            window.apstag.queue.push(function(){

                window.apstag.customPlacements().enable();
                window.adsNinjaAmazonResolve(true); // Allows promise-blocked apstag code to run.
            });
        } 
        catch(error){
            
            this.__logger.error(`Error initializing ASR: ${error}.`);
        }
    }

    // BETA: Testing for protected audience.
    if('DualShockers' === window.adsNinjaHeaderBiddingManager.getBrandName() && typeof aps == 'object' && aps && typeof aps.record == 'function'){

        aps.record("protectedAudience/allSlots/activate");
    }
};

window.ANBiddingLibraryAmazon = ANBiddingLibraryAmazon;